import { ICellRendererAngularComp } from 'ag-grid-angular';
import { Component } from '@angular/core';
import { StateLevelsService } from '../../../@core/utils';
import { TranslateModule } from '@ngx-translate/core';
import { NgStyle } from '@angular/common';

@Component({
    selector: 'app-technical-state-renderer',
    template: `
    @if (params.data || params.value) {
      <div class="technical-state-cell" [ngStyle]="color">
        @if (notation === null) {
          <div>
            <span class="technical-state-label">
              @if (showWithoutNotation) {
                {{ "Without notation" | translate }}
              } @else {
                -
              }
            </span>
          </div>
        }
        @if (notation !== null) {
          <div>
            <span class="technical-state-label">{{ label }}</span>
          </div>
        }
      </div>
    }
    `,
    standalone: true,
    imports: [
      NgStyle,
      TranslateModule
    ],
    styles: [`
      :host {
        display: block;
        width: 100%;
        height: 100%;
      }
      .technical-state-cell {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        text-align: center;
      }
      .technical-state-label {
        display: block;
        width: 100%;
      }
    `]
})
export class LastTechnicalStateRendererComponent
  implements ICellRendererAngularComp {
  public params: any;
  public color: any;
  public label: string;
  public notation : number;
  public showWithoutNotation: boolean = true;

  constructor(
    private stateLevelsService: StateLevelsService,
  ) { }

  agInit(params: any): void {
    this.params = params;
    this.showWithoutNotation = params.showWithoutNotation;
    const field = params.colDef.field;
    const raw = params.data?.[field] !== undefined ? params.data[field] : this.params.value;
    this.notation = (raw === null || raw === undefined) ? null : raw;

    if ((params.data || this.params.value) && this.notation !== null) {
      this.label = this.stateLevelsService.getTechnicalStateLabelFromNote(this.notation)
      if (this.notation > 0 && this.notation <= 22) {
        this.color = { 'background-color': '#ff8b94' };
      } else if (this.notation >= 23 && this.notation <= 46) {
        this.color = { 'background-color': '#ffaaa5' };
      } else if (this.notation >= 47 && this.notation <= 70) {
        this.color = { 'background-color': '#dcedc1' };
      } else if (this.notation >= 71 && this.notation <= 100) {
        this.color = { 'background-color': '#a8e6cf' };
      } else if (this.notation === 0) {
        this.color = { 'background-color': '#d9d9d9' };
      }
    }
  }

  refresh(): boolean {
    return false;
  }
}
